import { faSearch, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import VendorItemModel from "../models/vendor_item_model";
import Select from "react-select";
import ReactSelectOptionModel from "../../../commons/models/ReactSelectOptionModel";
import SizedDiv from "../../../commons/ui/sized_div";

interface Props {
    selectedVendorName: string;
    vendorItemModels: VendorItemModel[];
    vendorItemOptions: ReactSelectOptionModel[];
    searchKeyword: string;
    selectedItemId?: number;
    addedItemIds: number[];
    onChangeSelectedItemId: (id: number) => void;
    onAddItem: (id: number) => void;
    onChangeKeyword: (value: string) => void;
    onClose: () => void;
    onSubmit: () => void;
}

export default class VendorItemDashboardItemsModalWidget extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            // Dark BG
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 max-h-screen p-2">
                {/* The Modal */}
                <div className="relative bg-white rounded-lg shadow-lg mt-10 px-5 w-full max-w-4xl max-h-[83vh] overflow-y-auto">
                    <button
                        className="text-red-500 absolute right-3 top-3"
                        onClick={() => this.props.onClose()}
                    >
                        <FontAwesomeIcon icon={faX} />
                    </button>

                    <SizedDiv height={12} />

                    <h1 className="text-center font-bold text-lg mt-5">
                        Daftar Item "{this.props.selectedVendorName}"
                    </h1>

                    <SizedDiv height={12} />

                    <div className="sticky top-0 bg-white px-6 py-2 shadow-sm">
                        <div className="relative">
                            <input
                                type="text"
                                placeholder="Search..."
                                className="w-full border border-gray-300 rounded-lg my-2 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                onChange={(e) =>
                                    this.props.onChangeKeyword(e.target.value)
                                }
                                value={this.props.searchKeyword}
                            />
                            <FontAwesomeIcon
                                icon={faSearch}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div>
                        <div className="overflow-x-auto">
                            <table className="table-auto w-full text-center border-collapse my-2">
                                <thead>
                                    <tr className="bg-gray-300">
                                        <th className="p-2 border border-gray-400 w-1/5">
                                            Nama Item
                                        </th>
                                        <th className="p-2 border border-gray-400 w-1/5">
                                            Satuan Besar
                                        </th>
                                        <th className="p-2 border border-gray-400 w-1/5">
                                            Material Code
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Empty State */}
                                    {this.props.vendorItemModels.length ===
                                        0 && (
                                        <tr>
                                            <td
                                                colSpan={3}
                                                className="p-2 border border-gray-400"
                                            >
                                                <h3>Tidak ada item</h3>
                                            </td>
                                        </tr>
                                    )}

                                    {/* Data */}
                                    {this.props.vendorItemModels.map(
                                        (model) => (
                                            <tr key={model.id}>
                                                <td className="p-2 border border-gray-400">
                                                    {model.name}
                                                </td>
                                                <td className="p-2 border border-gray-400">
                                                    {model.bigUnit}
                                                </td>
                                                <td className="p-2 border border-gray-400">
                                                    {model.materialCode}
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Footer with item options & save button */}
                    <div className="mt-6 sticky bottom-0 bg-white px-4 py-6 shadow-inner">
                        <div className="w-full flex space-x-4 items-center">
                            <div className="flex-grow">
                                <Select
                                    placeholder="Tambah Item ?"
                                    className="basic-single w-full"
                                    classNamePrefix="select"
                                    isClearable
                                    isSearchable
                                    name="item"
                                    options={this.props.vendorItemOptions}
                                    onChange={(selectedOption) => {
                                        if (selectedOption) {
                                            const itemId = Number(
                                                selectedOption.value
                                            );
                                            this.props.onChangeSelectedItemId(
                                                itemId
                                            );
                                        }
                                    }}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                            </div>

                            <button
                                onClick={() => {
                                    if (this.props.selectedItemId) {
                                        this.props.onAddItem(
                                            this.props.selectedItemId
                                        );
                                    }
                                }}
                                className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 disabled:bg-gray-500"
                            >
                                Masukkan
                            </button>
                        </div>
                        <div className="mt-4">
                            <button
                                className="bg-green-500 disabled:bg-gray-400 text-white px-6 py-2 rounded-lg hover:bg-green-600 w-full"
                                onClick={() => this.props.onSubmit()}
                                disabled={this.props.addedItemIds.length === 0}
                            >
                                Simpan Data
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
